import { useEffect } from "react";

export type PrefetchFunction<T> = () => Promise<T>;
export type PostfetchFunction<T> = (data: T) => void;

export const useMount = <T>(fn: PrefetchFunction<T>) => ({
  then: (postFn: PostfetchFunction<T>) => {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    useEffect(() => {
      let mounted = true;
      void (async () => {
        const data = await fn();
        if (mounted) {
          postFn(data);
        }
      })();
      return () => {
        mounted = false;
      };
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
  },
});
